import {Injectable} from '@angular/core';
import {ModelProvider} from "../../../framework/providers/modelProvider/ModelProvider";
import {BusinessService} from "../../../core/services/BusinessService";
import {ModelToolsProvider} from "../../../framework/providers/model-tools/model-tools";
import {Events} from "../../../framework/providers/events";
import {AlertController} from "@ionic/angular";

@Injectable({providedIn: 'root'})
export class CashierService {
    appdata;

    total_data = {}

    ticketIds = [];
    ticketsData = {};

    nextItemId = 1;
    nextTicketId = 1;

    currentTicketId = null;

    constructor(private modelProvider: ModelProvider, public businessService: BusinessService, public modelTools: ModelToolsProvider,
                public events: Events, public alertCtrl: AlertController) {

    }

    start(appdata) {
        this.appdata = appdata;

        if (!this.currentTicketId) {
            this.addTicket();
        }
    }

    addTicket() {
        let ticketId = this.nextTicketId;
        if (!this.ticketsData[ticketId]) {
            this.ticketsData[ticketId] = {};
            this.ticketsData[ticketId]['itemsData'] = {};
            this.ticketsData[ticketId]['itemIds'] = [];

            this.ticketsData[ticketId]['itemsAmount'] = 0
            this.ticketsData[ticketId]['totalAmount'] = 0

            this.ticketsData[ticketId]['name'] = 'Ticket ' + ticketId
            this.ticketsData[ticketId]['props'] = {};
        }

        this.ticketIds.push(this.nextTicketId);
        this.currentTicketId = this.nextTicketId;

        this.nextTicketId += 1;
    }

    addToCart(itemId, subItemId = null) {
        let data = this.getItemCart(itemId, subItemId);

        let mainItem = data[0];
        let subItem = data[1];

        mainItem.amount += 1;

        if (subItem) {
            subItem.amount += 1;
        }

        this.calcItemProps(mainItem);
        return mainItem;
    }

    calcItemProps(mainItem) {
        //item props values calc
        let props = this.appdata['items_spec'][mainItem.itemId];
        if (!props) return;
        console.log(mainItem);
        for (let p of props) {
            console.log(p);
            if (!mainItem.props[p.id]) mainItem.props[p.id] = {'name': p['itpn'], 'value': 0, 'id': p.id}
            mainItem.props[p.id]['value'] += parseFloat(p['value']) * parseFloat(mainItem.amount);
        }

        //    calc amounts
        //    calc amounts
        //    calc amounts
        this.ticketsData[this.currentTicketId]['itemsAmount'] = 0;
        this.ticketsData[this.currentTicketId]['totalAmount'] = 0;
        let itemsAmount = 0;
        let totalAmount = 0;
        let cartItem;
        let ticket_props = {};
        for (let key in this.ticketsData[this.currentTicketId]['itemsData']) {
            cartItem = this.ticketsData[this.currentTicketId]['itemsData'][key];
            itemsAmount += 1;
            totalAmount += cartItem.amount;

            for (let propId in cartItem.props) {
                let prop = cartItem.props[propId];
                if (!ticket_props[prop['id']]) {
                    ticket_props[prop['id']] = {'name': prop['name'], 'value': 0};
                }
                ticket_props[prop['id']]['value'] += prop['value'];
            }
        }

        // this.ticketsData[this.currentTicketId]['answers'] = answers;
        this.ticketsData[this.currentTicketId]['itemsAmount'] = totalAmount;
        this.ticketsData[this.currentTicketId]['totalAmount'] = itemsAmount;
        this.ticketsData[this.currentTicketId]['props'] = ticket_props;//cf, pound ..

        //main item - sub item answers.
        if (mainItem.subItemIds.length > 0) {
            let answers = {};

            for (let currentSubItemId of mainItem.subItemIds) {
                let currentSubItem = mainItem.subItems[currentSubItemId];
                if (!currentSubItem['props']) continue;
                // item required questions
                for (let question of this.appdata['item_type_questions'][this.appdata['items'][mainItem.id]['itemType__id']]) {

                    if (!question['r']) continue;
                    if (!currentSubItem['props'][question['dgpid']]) continue;

                    for (let answerId of currentSubItem['props'][question['dgpid']]) {
                        let answer = this.appdata['answers_data'][answerId];
                        if (!answers[answer['id']]) {
                            answers[answer['id']] = {
                                'qname': question['n'],
                                'name': answer['name'],
                                'price': 0,
                                'icon': answer['icon'],
                                'i': question['i']
                            }
                        }
                        answers[answer['id']]['price'] += parseFloat(answer['price']) * parseFloat(currentSubItem['amount']);
                    }
                }
            }
            mainItem['answers'] = answers;
        }

        //ticket items answers
        let answers = {};
        for (let key in this.ticketsData[this.currentTicketId]['itemsData']) {
            let cartItem = this.ticketsData[this.currentTicketId]['itemsData'][key];
            for (let answerId in cartItem['answers']) {
                let answer = cartItem['answers'][answerId];
                if (!answers[answerId]) {
                    answers[answerId] = {
                        'qname': answer['n'],
                        'name': answer['name'],
                        'price': 0,
                        'icon': answer['icon'],
                        'i': answer['i']
                    }
                }
                answers[answerId]['price'] += parseFloat(answer['price']);
            }
        }
        this.ticketsData[this.currentTicketId]['answers'] = answers;

        this.total_data['itemsAmount'] = 0;
        this.total_data['totalAmount'] = 0;

        //    calc all tickets
        let all_props = {};
        for (let ticketId in this.ticketsData) {
            let ticket = this.ticketsData[ticketId];

            this.total_data['itemsAmount'] += ticket['itemsAmount'];
            this.total_data['totalAmount'] += ticket['totalAmount'];

            for (let propId in ticket['props']) {
                let prop = ticket['props'][propId];
                if (!all_props[prop['name']]) {
                    all_props[prop['name']] = {'name': prop['name'], 'value': 0};
                }
                all_props[prop['name']]['value'] += prop['value'];
            }
        }
        this.total_data['props'] = all_props;

        let all_answers = {};
        for (let ticketId in this.ticketsData) {
            let props = this.ticketsData[ticketId]['answers'];
            for (let propId in props) {
                let prop = props[propId];
                if (!all_answers[propId]) {
                    all_answers[propId] = {'name': prop['name'], 'price': 0, 'data': prop, 'id': propId};
                }
                all_answers[propId]['price'] += prop['price'];
            }
        }
        this.total_data['answers'] = all_answers;
    }

    removeFromCart(itemId, subItemId = null) {
        let data = this.getItemCart(itemId, subItemId);

        let mainItem = data[0];
        let subItem = data[1];

        data[0].amount -= 1;
        data[1].amount -= 1;
        this.ticketsData[this.currentTicketId]['amount'] -= 1;

        if (data[1].amount == 0) {
            data[0].subItemIds.splice(data[0].subItemIds.indexOf(subItemId), 1);
            data[0].subItems[subItemId] = null;
            delete data[0].subItems[subItemId];
        }

        if (data[0].amount == 0) {
            delete this.ticketsData[this.currentTicketId].itemsData[itemId];
            this.ticketsData[this.currentTicketId].itemIds.splice(this.ticketsData[this.currentTicketId].itemIds.indexOf(itemId), 1);
        }

        this.calcItemProps(mainItem);
    }

    setCurrentTicket(ticketId) {
        this.currentTicketId = ticketId;
    }

    trashFromCart() {

    }

    getItemCart(itemId, subItemId = null) {
        let ticketId = this.currentTicketId;

        if (!this.ticketsData[ticketId]) {
            this.ticketsData[ticketId] = {};
            this.ticketsData[ticketId]['itemsData'] = {};
            this.ticketsData[ticketId]['itemIds'] = [];
        }

        // if (!cartItemId) {
        //     cartItemId = this.nextItemId;
        //     this.nextItemId += 1;
        // }

        let cim;
        if (!this.ticketsData[ticketId]['itemsData'][itemId]) {
            cim = new CashierItemModel();
            cim.id = itemId;
            cim.amount = 0;
            cim.itemId = itemId;
            cim.subItemIds = [];
            cim.subItems = {};
            cim.props = {};
            cim.ticketId = ticketId;

            this.ticketsData[ticketId]['itemsData'][itemId] = cim;
            this.ticketsData[ticketId]['itemIds'].push(itemId);
        }

        cim = this.ticketsData[ticketId]['itemsData'][itemId];

        let subItem;
        if (!subItemId) {
            let subItemId = cim.subItemIds.length + 1;
            subItem = new CashierItemModel();
            subItem.id = subItemId;
            subItem.itemId = itemId;
            subItem.amount = 0;

            cim.subItems[subItemId] = subItem;
            cim.subItemIds.push(subItemId);
        } else {
            subItem = cim.subItems[subItemId];
        }

        console.log(this.ticketsData);
        console.log(ticketId, ' - ', cim.id);
        console.log(subItem);
        return [cim, subItem];
    }

    changeTicket(cartItem, newTicketId) {
        delete this.ticketsData[cartItem.ticketId].itemsData[cartItem.id];
        this.ticketsData[cartItem.ticketId].itemIds.splice(this.ticketsData[cartItem.ticketId].itemIds.indexOf(cartItem.id), 1);

        let ticket = this.ticketsData[newTicketId];
        cartItem.ticketId = newTicketId;

        //if all ready has this item by id.
        if (ticket.itemsData[cartItem.itemId]) {
            let mainItem = ticket.itemsData[cartItem.itemId];
            for (let subItemId in cartItem.subItems) {
                let subItem = cartItem.subItems[subItemId];
                let newSubItemId = mainItem.subItemIds.length + 1;
                subItem.id = newSubItemId;
                mainItem.subItems[newSubItemId] = subItem;
                mainItem.subItemIds.push(newSubItemId);
                mainItem.amount += subItem.amount;
            }
        } else {
            ticket.itemsData[cartItem.itemId] = cartItem;
            this.ticketsData[newTicketId].itemIds.push(cartItem.itemId);
        }

        this.calcItemProps(cartItem);
    }

    async removeTicket(ticketId) {
        const alert = await this.alertCtrl.create({
            header: 'areYouSure?',
            buttons: [
                {
                    text: 'no',//this.translate.instant('no'),
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: (blah) => {
                    }
                }, {
                    text: 'yes',//this.translate.instant('yes'),
                    handler: () => {
                        this.ticketIds.splice(this.ticketIds.indexOf(ticketId, 1));
                        delete this.ticketsData[ticketId];

                        if (this.ticketIds.length == 0) {
                            this.addTicket();
                        }
                        this.currentTicketId = this.ticketIds[0];
                    }
                }
            ]
        });

        await alert.present();

    }
}

export class CashierItemModel {
    id: number;
    itemId: number;
    comments: string;
    price: number;
    amount: number;
    props: any;

    subItems: any;
    subItemIds: any;
}







